import React, { useCallback, useState, useEffect, useContext, useRef } from 'react';
import css from './ViewPdf.module.scss';
import dynamic from 'next/dynamic';
import { t } from '../../common/components/T';
import { LangContext } from '../../common/decorators/Language';
import FormButtons from '../form/form-control-buttons/FormButtons/FormButtons';
import { navigateV2 } from '../../common/utils/router';
const PdfReader = dynamic(() => import('./pdfReder'), { ssr: false });

const ViewPdf = ({ documents, sender, setModal, cancellFunc }) => {
    const { translation } = useContext(LangContext) || {};
    const docs = documents || [];
    const total = docs.length;

    const [currentIndex, setCurrentIndex] = useState(0);
    const [readEnd, setReadEnd] = useState(false);

    const currentDoc = docs[currentIndex];
    const isLast = currentIndex >= total - 1;

    // --- NEW: refs для антидубля
    const lockRef = useRef(false);
    const lastRunRef = useRef(0);
    const readEndRef = useRef(readEnd);
    const indexRef = useRef(currentIndex);

    useEffect(() => {
        readEndRef.current = readEnd;
    }, [readEnd]);

    useEffect(() => {
        indexRef.current = currentIndex;
    }, [currentIndex]);

    // на зміну документа — скидаємо readEnd
    useEffect(() => {
        setReadEnd(false);
        readEndRef.current = false;
        // знімаємо lock при переході на новий документ
        lockRef.current = false;
    }, [currentIndex]);

    const handleNext = useCallback(() => {
        const nowTs = Date.now();

        // 1) часове вікно від дубля (touch/click/submit)
        if (nowTs - lastRunRef.current < 700) return;
        lastRunRef.current = nowTs;

        // 2) жорсткий lock
        if (lockRef.current) return;
        lockRef.current = true;

        try {
            if (!readEndRef.current) return;

            // одразу блокуємо повторний прохід у цьому ж тіку
            readEndRef.current = false;
            setReadEnd(false);

            if (indexRef.current >= total - 1) {
                if (typeof sender === 'function') sender();
                return;
            }

            setCurrentIndex((i) => i + 1);
        } finally {
            // важливо: не відпускаємо миттєво, щоб другий submit/click не пройшов
            setTimeout(() => {
                lockRef.current = false;
            }, 800);
        }
    }, [sender, total]);

    return (
        <div className={css.viewPdfWrap}>
            <div className={css.viewPdfBlock}>
                <PdfReader
                    key={currentDoc?.file?.link || currentIndex}
                    file={currentDoc?.file?.link}
                    fileData={currentDoc}
                    docs={docs}
                    currentIndex={currentIndex}
                    onReachedEnd={() => {
                        setReadEnd(true);
                        readEndRef.current = true;
                    }}
                    height='50vh'
                    thresholdPx={32}
                />
            </div>

            <FormButtons
                customFormButton={{
                    isFullWidth: true,
                    ok: { butWrapper: css.modalBtnEdit },
                    cancel: { butWrapper: css.modalBtnCancel }
                }}
                sendFormData={handleNext}
                buttons={[
                    {
                        type: 'cancel',
                        buttonText: t('logoutTitle', 'Выйти', 'all', translation),
                        clickFunc: () => {
                            if (cancellFunc) cancellFunc();
                            return typeof setModal === 'function' ? setModal(false) : navigateV2('/logout');
                        }
                    },
                    {
                        disabled: !readEnd || lockRef.current, // <-- NEW
                        type: 'ok',
                        buttonText: isLast
                            ? t('confirm', 'Подтвердить', 'all', translation)
                            : t('next-docs-sign', 'Следующий', 'all', translation)
                    }
                ]}
            />
        </div>
    );
};
export default ViewPdf;
